import { NJButton, NJText } from '@engie-group/fluid-design-system-react';
import { Dialog } from './Dialog';
import type { ProjectSummary } from './types';

export function V3Destination({ project, onClose }: { project: ProjectSummary | 'create'; onClose: () => void }) {
  const params = new URLSearchParams({ projets: 'mixte' });
  const profile = new URLSearchParams(window.location.search).get('as');
  if (profile === 'owner' || profile === 'write' || profile === 'read') params.set('as', profile);
  const href = `/plan2cost/prototype/plan-navigation-v3?${params}`;
  return (
    <Dialog id="pav-v3-destination" title={project === 'create' ? 'Créer dans Plan navigation V3' : 'Ouvrir dans Plan navigation V3'}
      onClose={onClose} footer={<div className="pav-dialog-actions">
        <NJButton label="Annuler" variant="secondary" onClick={onClose} />
        <NJButton label="Continuer vers l’accueil V3" icon="open_in_new" href={href} />
      </div>}>
      <NJText>Vous quittez ce prototype d’accueil. La destination est <strong>Plan navigation V3</strong>.</NJText>
      {project === 'create' ? <NJText>Sur son accueil, cliquez sur « Nouveau projet » pour utiliser l’assistant existant.</NJText>
        : <>
          <NJText>Sur son accueil, sélectionnez <strong>{project.name}</strong>.</NJText>
          <NJText scale="sm">Identifiant existant : {project.id}. Le paramètre « mixte » charge les quatre exemples Rennes ouvrables dans la V3.</NJText>
        </>}
      <NJText scale="sm">La V3 ne propose pas de lien direct vers ces écrans. Les modifications de partage faites ici ne sont pas transférées.</NJText>
    </Dialog>
  );
}
